<template>
  <n-modal class="user-documents" :loading="$var('load')" @close="$emit('close')">
    <h3>Документы пользователя</h3>
    <div class="name">{{ user.fullName }}</div>
    <div v-for="file in files" :key="file.id" class="document">
      <a :href="file.src" target="_blank">{{ file.name }}</a>
      <n-button v-if="editable" flat round icon="trash" @click="remove(file.id)" />
    </div>
    <div v-if="!files.length && !$var('load')" class="message">
      Документов нет
    </div>

    <n-button v-if="editable" class="add-button" @click="$var('create', true)">Добавить</n-button>

    <modal-add v-if="$var('create')" :user="user" @submit="load" @close="$var('create', false)" />
  </n-modal>
</template>

<script>
import ModalAdd from './ModalAdd'

export default {
  name: 'UserDocuments',
  components: { ModalAdd, },
  props: {
    user: { type: Object, required: true, },
    editable: { type: Boolean, default: false, },
  },
  data() {
    return {
      files: [],
    }
  },
  created() {
    this.load()
    this.$form.init({
      documents: [],
    })
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.users.documents.get(this.user.id).then((response) => {
        this.files = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove(id) {
      this.$var('load', true)
      $api.files.delete(id).then((response) => {
        this.load()
      }).catch(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.user-documents {
  --n-modal-width: 600px;

  h3 {
    margin-bottom: 0;
    font-size: .9em;
  }
  .name {
    font-size: 1.4em;
    margin-bottom: 10px;
  }
  
  .document {
    .n-button {
      margin-left: 5px;
      font-size: .8em;
    }
  }
  .add-button {
    margin-top: 15px;
  }
  .message {
    font-style: italic;
  }
}
</style>
